module.exports = __webpack_public_path__ + "media/images/favicon-logo-b151a8471bd7a04ace066bf113d2cae4.png";